const CLUB_CHANGES_MODAL_ENABLED = false;

class ToggleSwitch extends HTMLElement {
  static get observedAttributes() {
    return ['club-toggle', 'location'];
  }

  // ——— class-field handlers auto-bound to `this` ———
  handleToggle = () => this.toggleActive();
  handleCartUpdateEnriched = (event) => {
    const { cart, isClubProductInCart } = event.detail;
    this.cart = cart;
    this.isClubProductInCart = isClubProductInCart;
    this.updateButtonState();
  };

  handleJoinExtraClick = (event) => {
    // TODO: implement "join club extra CTA" behavior
    this.toggleActive();
  };

  handleModalClose = (e) => {
    if (e.target.returnValue === 'continue') {
      this.isClubProductInCart = true;
      this.setAttribute('club-toggle', 'true');
    }
  };

  constructor() {
    super();
    // initial state
    this.cart = {};
    this.isClubProductInCart = false;
    this.location = 'pdp';
  }

  connectedCallback() {
    this._cacheElements();
    if (!this.button || !this.srText) return;
    this._syncAttributes();
    this.updateButtonState();

    this.button.addEventListener('click', this.handleToggle);
    window.addEventListener('cartUpdateEnriched', this.handleCartUpdateEnriched);

    this.joinClubExtraButton?.addEventListener('click', this.handleJoinExtraClick);

    this._modal = document.getElementById('club-changes-modal');
    this._modal?.addEventListener('close', this.handleModalClose);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleToggle);
    window.removeEventListener('cartUpdateEnriched', this.handleCartUpdateEnriched);

    this.joinClubExtraButton?.removeEventListener('click', this.handleJoinExtraClick);

    this._modal?.removeEventListener('close', this.handleModalClose);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (oldVal === newVal) return;
    if (name === 'club-toggle') {
      this.isClubProductInCart = newVal === 'true';
      this.updateButtonState();
    } else if (name === 'location') {
      this.location = newVal || 'pdp';
    }
  }

  // ——— cache frequently-used elements once ———
  _cacheElements() {
    this.button = this.querySelector('.toggle-button');
    if (!this.button) {
      console.error('ToggleSwitch: .toggle-button not found');
      return;
    }
    this.srText = this.button.querySelector('.sr-only');
    if (!this.srText) {
      console.error('ToggleSwitch: .sr-only element not found');
    }
    // CTA button lives outside of this shadow/root
    this.joinClubExtraButton = document.querySelector('.join_members_club_extra_cta');
    this.joinClubExtraButtonWrapper = document.querySelector(
      '.join_members_club_extra_cta_wrapper'
    );
  }

  // ——— initialize from markup attributes ———
  _syncAttributes() {
    this.isClubProductInCart = this.getAttribute('club-toggle') === 'true';
    this.location = this.getAttribute('location') || 'pdp';
  }

  // toggle state & reflect back to attribute
  toggleActive() {
    if (CLUB_CHANGES_MODAL_ENABLED && !this.isClubProductInCart && this._modal) {
      this._modal.showModal();
      return;
    }
    this.isClubProductInCart = !this.isClubProductInCart;
    this.setAttribute('club-toggle', this.isClubProductInCart);
  }

  updateButtonState() {
    if (!this.button || !this.srText) return;

    if (this.isClubProductInCart) {
      this.button.classList.add('active');
      this.button.setAttribute('aria-pressed', 'true');
      this.srText.textContent = 'Remove Athletic Club Product';
      this.joinClubExtraButtonWrapper?.classList.add('hidden');
    } else {
      this.button.classList.remove('active');
      this.button.setAttribute('aria-pressed', 'false');
      this.srText.textContent = 'Add Athletic Club Product';
      this.joinClubExtraButtonWrapper?.classList.remove('hidden');
    }

    const eventName =
      this.location === 'pdp'
        ? 'pdp-toggle-club-membership'
        : 'subscription-builder-toggle-club-membership';

    this.dispatchEvent(
      new CustomEvent(eventName, {
        detail: {
          active: this.isClubProductInCart,
          product: this.athleticClubProduct,
        },
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define('toggle-switch', ToggleSwitch);

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.pricing_option_club_membership_top');
  const toggleSwitch = wrapper?.querySelector('toggle-switch');

  if (wrapper && toggleSwitch) {
    wrapper.addEventListener('click', (e) => {
      // Prevent double toggling when button is clicked directly
      if (e.target.closest('.toggle-button')) return;

      toggleSwitch.toggleActive();
    });
  }
});
